import React from 'react'
import { makeStyles, Hidden } from '@material-ui/core'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Navbar from './Navbar'
import Cajon from './Cajon'
import Inicio from './Inicio'
import Test from './Test'
import TestParteUno from './TestParteUno'
import TestParteDos from './TestParteDos'
import TestParteTres from './TestParteTres'
import ResultadosUno from './ResultadosUno'
import ResultadosDos from './ResultadosDos'
import ResultadosTres from './ResultadosTres'
import firebase from '../general/firebase'
import drawerImage from "../Front3.png";

const estilos = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: "theme.palette.background.default",
    backgroundImage: 'url(' + drawerImage + ')',
    minHeight: "100vh",
    padding: theme.spacing(3),
  },
  botonPersonalizado: {
    background: 'linear-gradient(45deg, #018786 30%, #018786 90%)',
    border: 0,
    borderRadius: 100,
    color: 'white',
    height: 48,
    padding: '5px 20px',
    fontSize: 20,
    fontWeight: 400,
  },
}))

const Contenedor = () => {
  const classes = estilos()

  //Hook para abrir y cerrar el Drawer
  const [abrir, setAbrir] = React.useState(false)
  const accionAbrir = () => {
    setAbrir(!abrir)
  }

  //Hook que almacena el estado de los Input en el componente: Text.jsx
  const [formState, setFormState] = React.useState({
    name: '',
    age: 0,
    radioAFiebre: 'end',
    radioBTos: 'end',
    radioCGarganta: 'end',
    radioDDiarrea: 'end',
    radioEOlfato: 'end',
    radioFErupciones: 'end',
    radioGColor: 'end',
    radioHRespirar: 'end',
  })

  const sendStateToFirebase = () => {
    const newReportRef = firebase.database().ref('reports/').push()
    newReportRef.set(formState)
  }

  //Arrow function que recibe "event"
  //Callback: una función como argumento de una función
  const handleChange = (event) => {
    console.log('event.target.value: ', event.target.value)
    setFormState((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }))
  }

  return (
    <Router>
      <div className={classes.root}>
        <Navbar accionAbrir={accionAbrir} formState={formState} />

        <Hidden mdUp>
          <Cajon
            accionAbrir={accionAbrir}
            variant="temporary"
            open={abrir}
            onClose={accionAbrir}
            formState={formState}
          />
        </Hidden>

        <div className={classes.content}>
          <div className={classes.toolbar}></div>
          <Switch>
            <Route path="/" exact>
              <Inicio formState={formState} setFormState={setFormState} />
            </Route>
            <Route path="/test">
              <Test formState={formState} handleChange={handleChange} />
            </Route>
            <Route path="/TestParteUno">
              <TestParteUno formState={formState} handleChange={handleChange} />
            </Route>
            <Route path="/TestParteDos">
              <TestParteDos formState={formState} handleChange={handleChange} />
            </Route>
            <Route path="/TestParteTres">
              <TestParteTres
                formState={formState}
                handleChange={handleChange}
                sendStateToFirebase={sendStateToFirebase}
              />
            </Route>
            <Route path="/resultados">
              <ResultadosUno />
            </Route>
            <Route path="/resultadosDos">
              <ResultadosDos />
            </Route>
            <Route path="/resultadosTres">
              <ResultadosTres />
            </Route>
            <Route path="/acercade">Esta es la pagina de "acerca de"</Route>
          </Switch>
        </div>
      </div>
    </Router>
  )
}

export default Contenedor
